var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hook-container"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.hookLoading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"loading"}):_vm._e()]),_c('div',{ref:`hook_${_vm.entidad || _vm.componente || 'hook'}`,staticClass:"hook"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }